import { useIsPanelOpen } from 'stores/usePanelsStateStore'
import { cn } from 'utils/cn'

import type { FC, PropsWithChildren } from 'react'

export const ConversationMenuOffsetWrapper: FC<PropsWithChildren> = ({ children }) => {
  const isConversationMenuPanelOpen = useIsPanelOpen('conversations_menu')

  return (
    <div
      className={cn(
        `flex justify-center transition-all lg:ml-[80px]`,
        {
          'xl:ml-[300px]': isConversationMenuPanelOpen,
        },
      )}
    >
      {children}
    </div>
  )
}
